import { Provider, signal } from '@angular/core';

import { ATTENTION_PROJECTIONS, AttentionProjection } from '@shared/services/attention/attention-projections';

import { MRP_RAIL } from './mrp.routes';

export { MRP_RAIL } from './mrp.routes';

/* What the MRP store last counted, published here so the ROOT projection reads it without importing
   the store — which would pull the whole plant into the app's initial chunk (the 7 MB budget; the
   gym's, the signage's and the hotel's pattern). Until Manufacturing has been opened this session
   there is nothing counted, and no badge. Nothing here may import the store, the records or the
   models (`mrp.routes.ts` is root-light too). */
const BLOCKED = signal(0);

/** What the store counted. */
export interface MrpBadgeCounts {
  /** Work orders that cannot run — Work orders (D150; a called supervisor still counts: it is still blocked). */
  readonly blocked: number;
}

/** The store's one write. */
export function publishMrpBadges(c: MrpBadgeCounts): void {
  if (BLOCKED() !== c.blocked) BLOCKED.set(c.blocked);
}

/**
 * MRP's rail badge (the DS `mrp.attention.ts`, D150/D158) — blocked jobs on Work orders, as the
 * source badges it (`mrp-app.jsx:69`): the one thing on this module nobody can proceed past.
 * `capKey: null` because the core screen is never gated — the badge follows the module.
 */
export function mrpAttentionProjections(): readonly AttentionProjection[] {
  return [
    {
      rule: { id: 'mrp.core.blocked', moduleId: 'mrp', capKey: null, railItemId: MRP_RAIL.orders, enabled: true, scope: 'site' },
      count: BLOCKED.asReadonly(),
      tone: signal('danger' as const).asReadonly(),
    },
  ];
}

/** Register MRP's projection at the root (AppModule), so the shell can show it. */
export function provideMrpAttention(): Provider[] {
  return [{ provide: ATTENTION_PROJECTIONS, useValue: mrpAttentionProjections, multi: true }];
}
